import { uniq } from 'lodash';

import { useLegacySalaryProposalWorkflowTableData } from '~/data/proposals/useGetLegacyProposalWorkflows';

import { useSalaryProposalColumns } from '../../../../common';
import {
  ProposalWorkflowTablePropsType,
  ProposalsWorkflowTableLayout,
} from '../common';

export const SalaryProposalWorkflowTable = (
  props: ProposalWorkflowTablePropsType,
) => {
  const { data: rows } = useLegacySalaryProposalWorkflowTableData(props);
  const columns = useSalaryProposalColumns({
    employmentIds: uniq(rows.map((r) => r.fEmplId)),
  });

  return <ProposalsWorkflowTableLayout rows={rows} columns={columns} />;
};
